module.exports = __webpack_public_path__ + "img/footer-logo.9ec121ac.png";